// App.jsx
import React from "react";
import "./LandingPage.css";

import Navbar from "./components/Navbar/Navbar";
import HeroCarousel from "./components/HeroCarousel/HeroCarousel";
import Features from "./components/Sections/Features/Features";
import SmartBookingSection from "./components/Sections/SmartBookingSection/SmartBookingSection";
import WhoItsForSection from "./components/Sections/WhoItsForSection/WhoItsForSection";
import CommunitySection from "./components/Sections/CommunitySection";
import WhoWeAreSection from "./components/Sections/WhoWeAreSection/WhoWeAreSection";
import ContactSection from "./components/Sections/ContactSection";
import AgenticBot from "./components/Sections/AgenticBot/AgenticBot";
import Footer from "./components/Footer/Footer";
import Hero2 from "./components/Sections/Hero2/Hero2";

function LandingPage() {
  return (
    <div className="app-root">
      <Navbar />
      <main>
        <HeroCarousel />
        <Hero2/>
        <Features />
        {/* <AgenticBot /> */}
        <SmartBookingSection />
        <WhoItsForSection />
        <CommunitySection />
        <WhoWeAreSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;
